import { useEffect, useState } from "react";
import ShowBarContent from "./ShowBarContent";
import "./showBar.css";
import axios from "axios";
import ShowBarEvidencije from "./Documents/ShowBarEvidencije";
import { useGlobalContext } from "../../../Context/Context";
import ShowBarProcenaRizika from "./Documents/ShowBarProcenaRizika";
import ShowBarPoslovneJedinice from "./Documents/show-bar-poslovne-jedinice/ShowBarPoslovneJedinice";
import ShowBarSredstvaOprema from "./Documents/show-bar-sredstva-oprema/ShowBarSredstvaOprema";
import ShowBarZastitaOdPozara from "./Documents/ShowBarZastitaOdPozara";
import ShowBarZastitaZivSredine from "./Documents/ShowBarZastitaZivSredine";
import ShowBarPoslovniSaradnici from "./Documents/ShowBarPoslovniSaradnici";
import ShowBarUgovoriOdluke from "./Documents/ShowBarUgovoriOdluke";
import ShowBarDokumentaZaposlenih from "./Documents/show-bar-dokumenta-zaposlenih/ShowBarDokumentaZaposlenih";
import Button from "../../Custom/Button/Button";
import ShowBarElektroOprema from "./Documents/show-bar-elektro-oprema/ShowBarElektroOprema";

const showBarDocumentsMapping = {
  EVIDENCIJE_OBRASCI: <ShowBarEvidencije />,
  PROCENA_RIZIKA: <ShowBarProcenaRizika />,
  POSLOVNE_JEDINICE: <ShowBarPoslovneJedinice />,
  SREDSTVA_OPREMA: <ShowBarSredstvaOprema />,
  ZASTITA_OD_POZARA: <ShowBarZastitaOdPozara />,
  ZASTITA_ZIVOTNE_SREDINE: <ShowBarZastitaZivSredine />,
  POSLOVNI_SARADNICI: <ShowBarPoslovniSaradnici />,
  UGOVORI_ODLUKE: <ShowBarUgovoriOdluke />,
  DOKUMENTA_ZAPOSLENIH: <ShowBarDokumentaZaposlenih />,
  ELEKTRO_OPREMA: <ShowBarElektroOprema />
};

const styles = {
  accountButton: {
    padding: "10px 0"
  }
};

const accountPreviewEmpty = {
  company_id: "",
  locations: [],
  archived_locations: [],
  users: [],
  archived_users: [],
  maxLocations: 5,
  maxUsers: 5
};

const ShowBar = () => {
  const [accountPreview, setAccountPreview] = useState(accountPreviewEmpty);

  const {
    selectedNavbarDocument,
    loggedUser,
    apiKey,
    selectedCompany,
    setSelectedCompany,
    selectedAccount,
    setSelectedAccount
  } = useGlobalContext();

  const handleClickAccount = async (id) => {
    if (accountPreview.company_id == id) {
      setAccountPreview(accountPreviewEmpty);
      return;
    }

    const { data } = await axios.post(
      "https://data.nadzor.app/api/admin_panel/companies/readAccountById.php",
      {
        user_id: loggedUser.id,
        api_key: apiKey,
        company_id: id
      }
    );
    if (data.status === 200) {
      setAccountPreview(data.data[0]);
    }
  };

  if (showBarDocumentsMapping[selectedNavbarDocument])
    return showBarDocumentsMapping[selectedNavbarDocument];

  return (
    <div className="showBar">
      {!accountPreview.company_id && (
        <>
          {selectedAccount ? (
            <>
              <ShowBarContent
                title="ЛОКАЦИЈЕ"
                list={selectedAccount.locations}
                listArchive={selectedAccount.archived_locations}
                maxList={selectedAccount.maxLocations}
                setSelectedItems={setSelectedAccount}
                companyId={selectedAccount.company_id}
              />
              <ShowBarContent
                title="КОРИСНИЦИ"
                list={selectedAccount.users.filter((u) => !u.predstavnik)}
                listArchive={selectedAccount.archived_users.filter(
                  (u) => !u.predstavnik
                )}
                maxList={selectedAccount.maxUsers}
                setSelectedItems={setSelectedAccount}
                companyId={selectedAccount.company_id}
              />
              <ShowBarContent
                title="ПРЕДСТАВНИЦИ"
                list={selectedAccount.users.filter((u) => u.predstavnik)}
                listArchive={selectedAccount.archived_users.filter(
                  (u) => u.predstavnik
                )}
                maxList={selectedAccount.maxUsers}
                setSelectedItems={setSelectedAccount}
                companyId={selectedAccount.company_id}
              />
            </>
          ) : (
            <>
              <ShowBarContent
                title="LOKACIJE"
                list={selectedCompany.locations}
                listArchive={selectedCompany.archived_locations}
                maxList={selectedCompany.maxLocations}
                setSelectedItems={setSelectedCompany}
                companyId={selectedCompany.company_id}
              />
              <ShowBarContent
                title="KORISNICI"
                list={selectedCompany.users}
                listArchive={selectedCompany.archived_users}
                maxList={selectedCompany.maxUsers}
                setSelectedItems={setSelectedCompany}
                companyId={selectedCompany.company_id}
              />
            </>
          )}
        </>
      )}

      {!selectedAccount &&
        selectedCompany.accounts.map((account) => (
          <div key={account.company_id}>
            <div onClick={() => handleClickAccount(account.company_id)}>
              <Button
                active={accountPreview.company_id == account.company_id}
                style={styles.accountButton}
              >
                {account.company_name}
              </Button>
            </div>
            {accountPreview.company_id == account.company_id && (
              <>
                <ShowBarContent
                  title="LOKACIJE"
                  list={accountPreview.locations}
                  listArchive={accountPreview.archived_locations}
                  maxList={accountPreview.maxLocations}
                  companyId={account.company_id}
                  setSelectedItems={setAccountPreview}
                />
                <ShowBarContent
                  title="KORISNICI"
                  list={accountPreview.users.filter((u) => !u.predstavnik)}
                  listArchive={accountPreview.archived_users.filter(
                    (u) => !u.predstavnik
                  )}
                  maxList={accountPreview.maxUsers}
                  companyId={account.company_id}
                  setSelectedItems={setAccountPreview}
                />
                <ShowBarContent
                  title="PREDSTAVNICI"
                  list={accountPreview.users.filter((u) => u.predstavnik)}
                  listArchive={accountPreview.archived_users.filter(
                    (u) => u.predstavnik
                  )}
                  maxList={accountPreview.maxUsers}
                  companyId={account.company_id}
                  setSelectedItems={setAccountPreview}
                />
              </>
            )}
          </div>
        ))}
    </div>
  );
};

export default ShowBar;
